import { render, staticRenderFns } from "./ProductItemVariationList.vue?vue&type=template&id=8f3b9792&scoped=true"
import script from "./ProductItemVariationList.vue?vue&type=script&lang=js"
export * from "./ProductItemVariationList.vue?vue&type=script&lang=js"
import style0 from "./ProductItemVariationList.vue?vue&type=style&index=0&id=8f3b9792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3b9792",
  null
  
)

export default component.exports